import type { FooterNavLink } from './footer';

export const footerData: FooterNavLink[] = [
  {
    linkUrl: '/sitemap/',
    linkLabel: 'Site Map',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-SITE_MAP',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://www.aarp.org/privacy/',
    linkLabel: 'AARP Privacy Hub',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-PRIVACY_HUB',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://www.aarp.org/about-aarp/terms-of-service/',
    linkLabel: 'Terms of Service',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-TOS',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://www.aarp.org/about-aarp/aarp-website-copyright-information/',
    linkLabel: 'Copyright Information',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-COPYRIGHT_INFO',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: '/sales/contactus/',
    linkLabel: 'Contact Us',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-CONTACT_US',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://optout.aboutads.info/',
    linkLabel: 'Ad Choices',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-AD_CHOICES',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://help.aarp.org/s/ccpa-request-page',
    linkLabel: 'Your Privacy Choices',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-PRIVACY_CHOICES',
    isDropDown: false,
    openNewTab: true,
  },
  {
    linkUrl: 'https://cp.email.aarp.org/driver-safety-refer-a-friend',
    linkLabel: 'Refer a Friend',
    formElementId: 'DRIVER-SAFETY-LNK-CLK-FTR-REFER_A_FRIEND',
    isDropDown: false,
    openNewTab: true,
  },
];
